import { Box, Skeleton } from "@mui/material";
import React from "react";

const CargandoLista = () => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, pt: 2}}>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
      <Skeleton variant="rounded" width="100%" height={30} sx={{borderRadius: 4}}/>
    </Box>
  );
};

export default CargandoLista;
